import { render } from "./Research.vue?vue&type=template&id=c9d368e8&scoped=true"
import script from "./Research.vue?vue&type=script&lang=js"
export * from "./Research.vue?vue&type=script&lang=js"

import "./Research.vue?vue&type=style&index=0&id=c9d368e8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-c9d368e8"

export default script